/**
 * AboutReviews.tsx — Gold Garage Door / About Us · Section 8/10
 * Cream · 3 quote cards + Elfsight widget. MOBILE: real <style> media queries.
 * ELFSIGHT id e48a8977-4fbd-41d9-a656-6a6d33f0fcb1. Perf via 10Web Booster JS-delay ONLY.
 *   No custom IO lazy-loader (broke reviews once). Inline platform.js fallback = site pattern.
 * 10WEB AI: keep Elfsight div + script + <style>. Waves intentional.
 */

import { useEffect } from "react";
const NAVY = "#081438";
const GOLD = "#F5A623";
const GOLD_DARK = "#9A6400";
const INK = "#1A1F2E";
const CREAM = "#FAF7F1";

/** quote — DO NOT REPLACE WITH IMG */
const Quote = () => <svg data-icon-container="lucide-do-not-replace" width="28" height="28" viewBox="0 0 24 24" fill={`${GOLD}33`} stroke={GOLD} strokeWidth="1.5"><path d="M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V20c0 1 0 1 1 1z" /><path d="M15 21c3 0 7-1 7-8V5c0-1.25-.757-2.017-2-2h-4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2h.75c0 2.25.25 4-2.75 4v3c0 1 0 1 1 1z" /></svg>;
const PICKS = [{
  q: "Spring snapped on a Sunday and they still came out same day. Fixed price, no drama, door's never run smoother.",
  n: "Daniel R.",
  s: "Bankstown"
}, {
  q: "Replaced our old roller door with a new motorised one. Tidy, on time, and they took the old one away. Five stars.",
  n: "Megan T.",
  s: "Cronulla"
}, {
  q: "Booked a service for the strata block — clear invoice, every door checked, great with the tenants. Will use again.",
  n: "Property Mgr",
  s: "Parramatta"
}];
export default function AboutReviews() {
  useEffect(() => {
    if (document.querySelector('script[src*="elfsight.com/platform.js"]')) return;
    const s = document.createElement("script");
    s.src = "https://static.elfsight.com/platform/platform.js";
    s.async = true;
    document.body.appendChild(s);
  }, []);
  return <section id="about-reviews" style={{
    background: CREAM,
    position: "relative",
    overflow: "hidden",
    paddingTop: "5.5rem",
    paddingBottom: "5.5rem"
  }}>
      <style>{`
        .arv-cards { display: grid; grid-template-columns: repeat(3, 1fr); gap: 1.25rem; margin-bottom: 3rem; }
        @media (max-width: 860px) {
          .arv-cards { grid-template-columns: 1fr; }
          #about-reviews { padding-top: 3.5rem; padding-bottom: 3.5rem; }
        }
      `}</style>

      <div aria-hidden style={{
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      lineHeight: 0,
      transform: "rotate(180deg)"
    }}>
        <svg viewBox="0 0 1440 48" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{
        display: "block",
        width: "100%",
        height: "48px"
      }}><path d="M0,48 C360,0 1080,0 1440,48 L1440,48 L0,48 Z" fill={NAVY} /></svg>
      </div>

      <svg aria-hidden style={{
      position: "absolute",
      inset: 0,
      width: "100%",
      height: "100%",
      opacity: 0.4,
      pointerEvents: "none",
      mixBlendMode: "multiply"
    }}><filter id="paper-ar"><feTurbulence type="fractalNoise" baseFrequency="0.04" numOctaves="5" stitchTiles="stitch" /><feColorMatrix type="matrix" values="0 0 0 0 0.85, 0 0 0 0 0.82, 0 0 0 0 0.74, 0 0 0 0.08 0" /></filter><rect width="100%" height="100%" filter="url(#paper-ar)" /></svg>

      <div style={{
      maxWidth: "1150px",
      margin: "0 auto",
      padding: "0 1.5rem",
      position: "relative",
      zIndex: 1
    }}>
        <div style={{
        textAlign: "center",
        maxWidth: "620px",
        margin: "0 auto 3rem"
      }}>
          <span style={{
          fontFamily: "'Manrope', sans-serif",
          fontSize: "0.72rem",
          fontWeight: 700,
          letterSpacing: "0.16em",
          color: GOLD_DARK,
          textTransform: "uppercase"
        }}>Straight From Google</span>
          <h2 style={{
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          fontWeight: 800,
          fontSize: "clamp(1.65rem, 6vw, 2.6rem)",
          color: NAVY,
          lineHeight: 1.15,
          margin: "0.75rem 0 0.75rem"
        }}>A 5.0 rating we've earned the hard way</h2>
          <p style={{
          fontFamily: "'Manrope', sans-serif",
          fontSize: "1.02rem",
          color: INK,
          lineHeight: 1.7
        }}>Every review is from a real Sydney customer. Here are a few — then read the rest live below.</p>
        </div>

        <div className="arv-cards">
          {PICKS.map((p, i) => <div key={i} style={{
          background: "#fff",
          border: `1px solid ${GOLD}30`,
          borderRadius: "14px",
          padding: "1.75rem",
          boxShadow: "0 8px 28px rgba(8,20,56,0.07)",
          display: "flex",
          flexDirection: "column",
          gap: "1rem"
        }}>
              <Quote />
              <p style={{
            fontFamily: "'Manrope', sans-serif",
            fontSize: "0.98rem",
            color: INK,
            lineHeight: 1.65,
            flexGrow: 1
          }}>"{p.q}"</p>
              <div style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            borderTop: `1px solid ${GOLD}22`,
            paddingTop: "0.85rem"
          }}>
                <div>
                  <div style={{
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                fontWeight: 700,
                fontSize: "0.9rem",
                color: NAVY
              }}>{p.n}</div>
                  <div style={{
                fontFamily: "'Manrope', sans-serif",
                fontSize: "0.78rem",
                color: GOLD_DARK
              }}>{p.s}</div>
                </div>
                <div style={{
              color: GOLD,
              fontSize: "0.9rem",
              letterSpacing: "1px"
            }}>★★★★★</div>
              </div>
            </div>)}
        </div>

        <div style={{
        background: "#fff",
        border: `1px solid ${GOLD}25`,
        borderRadius: "16px",
        padding: "1.5rem",
        boxShadow: "0 8px 28px rgba(8,20,56,0.06)"
      }}>
          <div className="elfsight-app-e48a8977-4fbd-41d9-a656-6a6d33f0fcb1" data-elfsight-app-lazy></div>
        </div>
      </div>

      <div aria-hidden style={{
      position: "absolute",
      bottom: 0,
      left: 0,
      right: 0,
      lineHeight: 0
    }}>
        <svg viewBox="0 0 1440 48" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{
        display: "block",
        width: "100%",
        height: "48px"
      }}><path d="M0,48 C360,0 1080,0 1440,48 L1440,48 L0,48 Z" fill={NAVY} /></svg>
      </div>
    </section>;
}